import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';

// material component
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';

const indexOfObject = (arrayObject, key) => {
	let i;
	arrayObject.forEach((object, index) => {
		if (object.pos == key) {
			return i = index ;
		}
	});
	return i;
}

const searchObjectFunction = (array, pos) => {
	let val;
	array.forEach((object) => {
		if (object.pos == pos) {
			return val = object ;
		}
	});
	return val;
}

const isTheLastElt = (arrayObject, index) => {
	return (arrayObject.length-1 === index)
}

const isTheFirstElt = (index) => {
	return index === 0;
}

const nextElement = (arrayObject, params) => {
	let domaineMain = arrayObject.domaine;

	let relIndex = indexOfObject(domaineMain.referentiel, params.rel);
	let rel = searchObjectFunction(domaineMain.referentiel, params.rel);

	let refIndex = indexOfObject(rel.references, params.ref);
	let ref = searchObjectFunction(rel.references, params.ref);
	
	let crIndex = indexOfObject(ref.criteres, params.cr);
	let cr = searchObjectFunction(ref.criteres, params.cr);

	if (!isTheLastElt(ref.criteres, crIndex)) {
		let suivant = ref.criteres[crIndex+1] ;
		return `/domaine/1/${params.rel}/${params.ref}/${suivant.pos}`;
	}
	else if (!isTheLastElt(rel.references, refIndex)) {
		let suivant = rel.references[refIndex+1];
		return `/domaine/1/${params.rel}/${suivant.pos}/${suivant.criteres[0].pos}`;
	}
	else if (!isTheLastElt(domaineMain.referentiel, relIndex)) {
		let suivant = domaineMain.referentiel[relIndex+1];
		return `/domaine/1/${suivant.pos}/${suivant.references[0].pos}/${suivant.references[0].criteres[0].pos}`
	}
	return 'false';
}

const lastElement = (arrayObject, params) => {
	let domaineMain = arrayObject.domaine;

	let relIndex = indexOfObject(domaineMain.referentiel, params.rel);
	let rel = searchObjectFunction(domaineMain.referentiel, params.rel);

	let refIndex = indexOfObject(rel.references, params.ref);
	let ref = searchObjectFunction(rel.references, params.ref);
	
	let crIndex = indexOfObject(ref.criteres, params.cr);
	let cr = searchObjectFunction(ref.criteres, params.cr);

	if (!isTheFirstElt(crIndex)) {
		let precedent = ref.criteres[crIndex-1] ;
		return `/domaine/1/${params.rel}/${params.ref}/${precedent.pos}`;
	}
	else if (!isTheFirstElt(refIndex)) {
		let precedent = rel.references[refIndex-1];
		return `/domaine/1/${params.rel}/${precedent.pos}/${precedent.criteres[precedent.criteres.length-1].pos}`;
	}
	else if (!isTheFirstElt(relIndex)) {
		let precedent = domaineMain.referentiel[relIndex-1];
		let last = precedent.references.length-1;
		let lastCr = precedent.references[last].criteres.length-1;
		return `/domaine/1/${precedent.pos}/${precedent.references[last].pos}/${precedent.references[last].criteres[lastCr].pos}`
	}
	else {
		return 'false';
	}
}

const Pagination = ({data, params}) => {
	let last = lastElement(data, params);
	let next = nextElement(data, params);

	/* useEffect(() => {
		//console.log(data, params)
		console.log(nextElement(data, params))
		console.log(lastElement(data, params))
	}) */

	const CustomBtnLink = ({text, link, disabled}) => {
		return (
			<Button variant="outlined" color="primary" disabled={disabled}>
				<Link to={link} style={{ textDecoration: 'none', color: 'inherit'}}>
					{text}
				</Link>
			</Button>
		)
	}

	return (
		<Grid container item direction='row' alignItems='center' justify='space-between' style={{width: '100%', marginBottom: '2%'}}>
			<CustomBtnLink text='Précédent' link={last == 'false' ? '' : last} disabled={last == 'false' ? true : false} />
			<CustomBtnLink text='Suivant' link={next == 'false' ? '' : next} disabled={next == 'false' ? true : false} />
		</Grid>
	)
}

export default Pagination;